import { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { Dropzone } from "@benefit-systems/hr-tools-ui";
import __ from "src/utils/Translations";
import UploadFile from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface ImportFileUploaderProps {
  uploadedFile: File | null;
  onFileAccepted: (file: File) => void;
  onFileRemove: () => void;
}

const ImportFileUploader: FC<ImportFileUploaderProps> = ({
  uploadedFile,
  onFileAccepted,
  onFileRemove,
}) => (
  <Box sx={{ mt: 2, mb: 1 }} data-testid="os__import-file-uploader">
    {!uploadedFile ? (
      <Dropzone
        onFilesAccepted={(files) => {
          if (files && files.length > 0) {
            const { file } = files[0];
            onFileAccepted(file);
          }
        }}
        activeLinkText={__("Wybierz plik z dysku")}
        acceptTypes={[
          {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            label: "XLSX",
          },
          {
            type: "text/csv",
            label: "CSV UTF-8 rozdzielany średnikami",
          },
        ]}
        maxFiles={1}
        maxFileSize={5}
        translateFunction={__}
        showInlineErrors
        showInvalidFiles
      />
    ) : (
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          padding: 2,
        }}
        data-testid="os__import-file-uploaded"
      >
        <Stack direction="row" sx={{ alignItems: "center", gap: 2 }}>
          <UploadFile sx={{ fontSize: 20, color: "#3b82f6" }} />
          <Stack>
            <Typography variant="subtitle1" sx={{ fontWeight: 400 }}>
              {uploadedFile.name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {(uploadedFile.size / 1024).toFixed(2)} KB • Complete
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="row" sx={{ gap: 3 }}>
          <DeleteIcon
            onClick={onFileRemove}
            data-testid="os__import-file-remove-button"
            sx={{ fontSize: 20, color: "#707070", cursor: "pointer" }}
          />
          <CheckCircleIcon sx={{ fontSize: 20, color: "#2E7D32" }} />
        </Stack>
      </Stack>
    )}
  </Box>
);

export default ImportFileUploader;
